import { getProductUidsFromSanityProductVariations } from './getProductUidsFromSanityProductVariations';

export const getProductUidsFromSanityProduct = (sanityProduct): string[] => {
  if (!sanityProduct) {
    return [];
  }

  return getProductUidsFromSanityProductVariations(sanityProduct.productVariations);
};
